var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcLocationPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#576078",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.177
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.813 5.935C.813 2.657 3.358 0 6.5 0c3.141 0 5.688 2.657 5.688 5.935 0 2.185-1.896 5.012-5.688 8.479C2.708 10.947.812 8.12.812 5.935z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M0 16.608h13"
  })), /*#__PURE__*/React.createElement("ellipse", {
    strokeWidth: 1.089,
    cx: 6.5,
    cy: 6.035,
    rx: 1.625,
    ry: 1.646
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocationPin);
export default __webpack_public_path__ + "static/media/ic_location_pin.02b0faee4f9f1b5c35a310587c46e98f.svg";
export { ForwardRef as ReactComponent };